import { render, staticRenderFns } from "./recommanderManage.vue?vue&type=template&id=9a855be0&scoped=true"
import script from "./recommanderManage.vue?vue&type=script&lang=ts"
export * from "./recommanderManage.vue?vue&type=script&lang=ts"
import style0 from "./recommanderManage.vue?vue&type=style&index=0&id=9a855be0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a855be0",
  null
  
)

export default component.exports